<template lang="html">
  <PrimeDropdown
    :disabled="disabled"
    :filter="filterable" :filterPlaceholder="$t('Поиск...')"
    :emptyFilterMessage="$t('Ничего не найдено')"
    optionLabel="filterName"
    optionValue="number"
    :showClear="allowClear && hasSelected"
    dataKey="system"
    scrollHeight="250px"
    :placeholder="$t('Выберите счет...')"
    :options="filteredAccounts"
    v-model="val"
    class="payout-accounts-dropdown">
    <template #value="slotProps">
      <template v-if="slotProps.value && selectedAccount">
        <div class="dropdown-selected-body">
          <div class="dropdown-accounts-list-item noselect">
            <div class="dropdown-accounts__li__content">
              <div class="account-block">
                <div>
                  <dropdown-account-currency-icon
                    :currency="selectedAccount.currency"></dropdown-account-currency-icon>
                </div>
                <div>
                  <div class="account-block__number">{{ selectedAccount.number }}</div>
                  <div class="account-block__name__wrap">
                    <dropdown-account-crypto-system-icon
                      :account="selectedAccount"></dropdown-account-crypto-system-icon>
                    <span class="account-block__name">&laquo;{{
                        selectedAccount.name
                      }}&raquo;</span>
                  </div>
                </div>
                <div class="account-block__balance">
                  <div class="account-block__balance_amount">
                    {{ MoneyFormatFilter(selectedAccount.availBalance, selectedAccount.currency) }}
                  </div>

                  {{ selectedAccount.currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <template v-if="allowClear">-->
        <!--          <i class="p-dropdown-clear-icon pi pi-times" @click.stop.prevent="clearValue"></i>-->
        <!--        </template>-->
      </template>
      <template v-else>{{ slotProps.placeholder }}</template>
    </template>
    <template #option="{option}">
      <div class="dropdown-accounts-list-item noselect">
        <div class="dropdown-accounts__li__content">
          <div class="account-block">
            <div>
              <dropdown-account-currency-icon
                :currency="option.currency"></dropdown-account-currency-icon>
            </div>
            <div>
              <div class="account-block__number">{{ option.number }}</div>
              <div class="account-block__name__wrap">
                <dropdown-account-crypto-system-icon
                  :account="option"></dropdown-account-crypto-system-icon>
                <span class="account-block__name">&laquo;{{ option.name }}&raquo;</span>
              </div>
            </div>
            <div class="account-block__balance">
              <div class="account-block__balance_amount">
                {{ MoneyFormatFilter(option.availBalance, option.currency) }}
              </div>

              {{ option.currency }}
            </div>
          </div>
        </div>
      </div>
    </template>

  </PrimeDropdown>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import {formatUnixDateFilter} from '@/models/filters/datetime';
import {MoneyFormatFilter} from '@/models/filters/money';
import {Account} from '@/models/finance/account';
import DropdownAccountCurrencyIcon
  from '@/components/forms/dropdown/DropdownAccountCurrencyIcon.vue';
import DropdownAccountCryptoSystemIcon
  from '@/components/forms/dropdown/DropdownAccountCryptoSystemIcon.vue';
import ClearIconSvg from "@/components/forms/dropdown/ClearIconSvg.vue";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";
import {
  accountsAutoconvertCurrencySortingCb,
  accountsBalanceSortingCb,
  accountsCurrencySortingCb,
  accountsNumberSortingCb
} from "@/components/forms/payout/payout-basics";

@Component({
  name: 'prime-dropdown-accounts',
  components: {
    PrimeDropdown,
    ClearIconSvg, DropdownAccountCryptoSystemIcon, DropdownAccountCurrencyIcon,
  },
  methods: {
    formatUnixDateFilter,
    MoneyFormatFilter,
  },
})
export default class PrimeDropdownAccounts extends Vue {
  @Prop({required: true})
  accounts!: Account[]

  @Prop({required: true})
  value!: string | Account | null

  @Prop({default: false})
  selectionObject: boolean

  @Prop({default: false})
  disabled!: boolean

  @Prop({default: null})
  currency: string | string[] | any

  @Prop({default: false})
  allowClear!: boolean

  @Prop({default: false})
  includeCardsPro!: boolean

  get val() {
    return this.$props.value;
  }

  get filterable() {
    return this.accounts && this.accounts.length > 10;
  }

  set val(val) {
    const account = this.accounts?.find((account: Account) => account.number === val);
    if (!account)
      this.$emit('input', null);
    else
      this.$emit('input', this.selectionObject ? account : account.number);
  }

  get filteredAccounts() {
    if (!this.accounts) return [];

    let result = this.accounts?.filter((account: Account) => {
      return this.includeCardsPro || !account.isCardsPro;
    }) || [];

    if (this.currency) {
      if (typeof this.currency === 'string') {
        result = result.filter((account: Account) => {
          return (account.currency === this.currency)
        });
      } else if (Array.isArray(this.currency)) {
        result = result.filter((account: Account) => {
          return (this.currency.indexOf(account.currency) >= 0);
        });
      }
    }
    return result
      .map((account: Account) => {
        return {
          ...account,
          filterName: `${account.number} ${account.name} ${account.currency}`.toLowerCase()
        }
      })
      .sort(accountsNumberSortingCb)
      .sort(accountsBalanceSortingCb)
      .sort(accountsCurrencySortingCb)
      .sort(accountsAutoconvertCurrencySortingCb)
  }

  get selectedAccount() {
    if (this.selectionObject && (typeof this.value === 'object') && this.value) return this.value;

    if (!this.accounts) return null;

    if (typeof this.value === 'string') {
      return this.accounts.find((account: Account) => account.number === this.value);
    }
    return null;
  }

  @Watch('selectedAccount')
  onSelectedAccountUpdate(newVal) {
    if (!newVal) return null;

    if (!this.isValidAccount(newVal?.number))
      this.$emit('input', null);
  }

  onMounted() {
    this.onSelectedAccountUpdate(this.selectedAccount);
  }

  isValidAccount(accountNumber: string): boolean {
    if (this.filteredAccounts.length == 0) return true;
    return this.filteredAccounts.some((account: Account | any) => account?.number == accountNumber);
  }

  get hasSelected() {
    return !!this.selectedAccount;
  }

}
</script>

<style scoped lang="less">
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                   supported by Chrome, Edge, Opera and Firefox */
}

.payout-accounts-dropdown.p-dropdown::v-deep {

  &.p-dropdown-clearable {
    display: flex;
    gap: 3px;
    flex-direction: row;
    width: 100%;

    .p-dropdown-clear-icon {


      position: relative;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      margin: 0;
      font-weight: bold;

      &::before {
        font-weight: bold;
        //padding: 10px 15px;
        cursor: pointer;

        background: rgba(155, 189, 82, 0.5);
        padding: 5px;
        border-radius: 50%;
        color: #333;

        transition: background 0.2s, color 0.2s;
      }

      &:hover {
        &::before {
          background: #80bd1c;
          color: #fff;
        }
      }

      //display: flex;
      //flex-direction: row;
      //gap: 15px;
      //align-items: center;
      //justify-content: flex-start;

      //margin-right: 10px;
      //margin-left: 10px;
      //border: #0b4d85 1px solid;
      //border-radius: 50%;
      //padding: 5px;
    }
  }


  min-height: 4.8rem;
  height: auto;

  .p-dropdown-label {
    padding-top: 0.7em;
    padding-bottom: 0.7em;
  }

  .p-dropdown-items {
    .p-dropdown-item {
      padding-top: 0.5em;
      padding-bottom: 0.5em;
    }
  }

  .dropdown-accounts__li__content {
    display: grid;
    grid-template-columns: auto;
    grid-gap: 3px 8px;
    grid-auto-columns: min-content;

    .content__name {
      grid-column-start: 1;
      grid-column-end: 3;
      font-size: 85%;
    }

    .content__number, .content__amount {
      font-weight: bolder;
    }

    .content__amount {
      text-align: right;
    }
  }

  .dropdown-selected-body {
    //padding-right: 10px;
    display: block;
    width: 100%;
    //border-right: 1px solid #ddd;
    .p-inputtext {
      padding-right: 0;
    }
  }
}

.account-block {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: max-content auto max-content;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  align-items: center;

  .account-block__number {
    font-weight: bold;
    //font-size: 110%;
    line-height: 1em;
    padding-bottom: 3px;
  }

  .account-block__name {
    line-height: 1em;
    font-size: 90%;

    white-space: normal;
    word-break: break-word;
  }

  .account-block__name__wrap {
    line-height: 1em;

    .dropdown-account-crypto-system-icon {
      font-weight: bold;
      margin-right: 5px;
    }
  }

  .account-block__balance {
    > div {
      display: inline-block;
    }

    .account-block__balance_amount {
      font-weight: bold;
    }
  }
}

</style>

<i18n>
{
  "en": {
    "Выберите счет...": "Please select account...",
    "Снять выбор": "Clear selection",
    "Выберите": "Please select",
    "Выберите счет": "Please select account",
    "Поиск...": "Search...",
    "Ничего не найдено": "Nothing found"
  }
}
</i18n>
